import React, { Component } from "react";
import { connect } from "react-redux";
import Container from "src/shared/Container";
import withModules from "src/utils/hoc/withModules";
import DashboardLayout from "src/scenes/layouts/DashboardLayout";
import { default as SharedProfile } from "src/shared/Profile";
import { AccountPersist } from "src/ducks/Persist";

const ShowAccount = AccountPersist("ProfileShow");

const modules = [ShowAccount.module()];

class Profile extends Component {
  render() {
    const { account } = this.props;

    return (
      <DashboardLayout title={account ? account.username : "Loading..."}>
        <Container>
          <SharedProfile />
        </Container>
      </DashboardLayout>
    );
  }
}

const mapStateToProps = state => ({
  account: ShowAccount.selectOne(state)
});

const mapDispatchToProps = {};

export default withModules(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Profile)
)(modules);
